// import { API_BASE_URL } from 'configs/AppConfig'
import LabelLang from 'component/LabelLang/label-lang'
import { FormattedMessage } from 'react-intl'

export default function Value({title , desc , imgTitle , translation}) {
  return (
    <div className="col-11 col-md-6">
        <div className="item-q">
          <div className="item-icon">
            <img 
                src={imgTitle}
                alt="img-icon"
                loading="lazy"
            />
          </div>
          <div className="d-flex flex-column">
            <h6>
              {translation !== null && translation !== undefined ? (
                <LabelLang
                  id="title"
                  defaultValue={title}
                  translations={translation}
                />
              ) : (
                <FormattedMessage id="data-not-found" />
              )}
            </h6>
            <p> <LabelLang
              id="description"
              defaultValue={desc}
              translations={translation}
            /></p>
          </div>
        </div>
    </div>
  )
}
